// Notification-template endpoints that are NOT super-admin-only.
//
// The `preview` renderer serves Settings → Workspace → Notifications (a tenant
// member holding the support-settings grant) and Super Admin → Templates (the
// global default, no tenant — super admin only, ADR 031 — Config Ownership), so
// it lives outside the `super_admin` namespace. The auction-scope preview is its
// own route, `auctions.id.notification_preview` (BL-1833). The super-admin-only
// template CRUD (`/api/super-admin/notification-templates` + `:id`) stays under
// `super_admin`.
import { responseType } from '@auctogon/core/api/registry';
import { defineAdminRoute } from './define-admin-route';
import type { NotificationTemplatePreviewDto } from '../../schemas/responses/notification-template-preview';

export const notification_templates = {
  preview: defineAdminRoute({
    path: '/api/notification-templates/preview',
    params: {},
    // BL-1353 — the response DTO is threaded here so the route's `respond(...)`
    // and the client's `api.notification_templates.preview.post(...)` reference
    // ONE declaration. The component no longer hand-declares a twin.
    //
    // BL-1833: the tenant is the body's `tenantId`, validated against
    // membership. `optional` because the global default carries none — then
    // only a super admin passes the grant check.
    methods: {
      POST: {
        grant: 'settings.update_support',
        tenant: { from: 'input', field: 'tenantId', in: 'body', optional: true },
        response: responseType<NotificationTemplatePreviewDto>(),
      },
    },
  }),
};
